<div class="content">
  <span>{{ "pendingTagIdBar.name" | translate }}</span>
  <span>{{ pendingTagId }}</span>
  <button mat-flat-button color="warn" (click)="discard.emit()">
    {{ "pendingTagIdBar.discardButton" | translate }}
  </button>
</div>
